'use strict';

var MarketProductGroupDateRangeLevelChartAggregationFactory = function MarketProductGroupDateRangeLevelChartAggregationFactory(DataAggregationFactory, ExtractMetricKeysService, momentService) {
  function MarketProductGroupDateRangeLevelChartAggregation() {
    DataAggregationFactory.call(this, ['market-product-group', 'market'], 'date-range-level-chart');
  }
  MarketProductGroupDateRangeLevelChartAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  MarketProductGroupDateRangeLevelChartAggregation.prototype.canAggregate = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && targetType === this.targetType;
  };
  MarketProductGroupDateRangeLevelChartAggregation.constructor = MarketProductGroupDateRangeLevelChartAggregation;
  MarketProductGroupDateRangeLevelChartAggregation.prototype.aggregate = function (data, metrics) {
    var aggregationFunction = this.getAggregationFunction(metrics);
    var groupedData = {},
      keys,
      keysLength,
      metricKeys;
    for (var index = 0, dataLength = data.length; index < dataLength; index++) {
      if (Array.isArray(groupedData[data[index].departureDate])) {
        groupedData[data[index].departureDate].push(data[index]);
      } else {
        groupedData[data[index].departureDate] = [data[index]];
      }
    }
    keys = Object.keys(groupedData);
    for (index = 0, keysLength = keys.length; index < keysLength; index++) {
      var reducedEntry = {};
      var date = keys[index];
      reducedEntry.departureDateMoment = momentService.of(date, momentService.FIELD.DEPARTURE_DATE, momentService.FORMAT.DATE_ISO);
      reducedEntry.created = momentService.of(date, momentService.FIELD.CREATED_DATE, momentService.FORMAT.DATE_ISO);
      metricKeys = ExtractMetricKeysService.extract(groupedData[date][0]);
      aggregationFunction(groupedData[date], metricKeys, reducedEntry);
      groupedData[date] = reducedEntry;
    }
    return this.sortAggregationResults(groupedData);
  };
  return MarketProductGroupDateRangeLevelChartAggregation;
};
MarketProductGroupDateRangeLevelChartAggregationFactory.$inject = ['DataAggregationFactory', 'ExtractMetricKeysService', 'MomentService'];
module.exports = MarketProductGroupDateRangeLevelChartAggregationFactory;